"use strict";
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpportunityPreviousMediatorDetails = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const opportunity_entity_1 = require("./opportunity.entity");
const company_entity_1 = require("./company.entity");
const country_entity_1 = require("./country.entity");
const city_entity_1 = require("./city.entity");
let OpportunityPreviousMediatorDetails = class OpportunityPreviousMediatorDetails {
    constructor(id, opportunityId, companyId, locationId, branchId, mediatorTypeId) {
        this.id = id;
        this.opportunityId = opportunityId;
        this.companyId = companyId;
        this.locationId = locationId;
        this.branchId = branchId;
        this.mediatorTypeId = mediatorTypeId;
    }
};
exports.OpportunityPreviousMediatorDetails = OpportunityPreviousMediatorDetails;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], OpportunityPreviousMediatorDetails.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "opportunity_id" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPreviousMediatorDetails.prototype, "opportunityId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "company_id" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPreviousMediatorDetails.prototype, "companyId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "location_id" }),
    tslib_1.__metadata("design:type", typeof (_a = typeof Number !== "undefined" && Number) === "function" ? _a : Object)
], OpportunityPreviousMediatorDetails.prototype, "locationId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "branch_id" }),
    tslib_1.__metadata("design:type", typeof (_b = typeof Number !== "undefined" && Number) === "function" ? _b : Object)
], OpportunityPreviousMediatorDetails.prototype, "branchId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "mediator_type_id", type: "int" }),
    tslib_1.__metadata("design:type", typeof (_c = typeof Number !== "undefined" && Number) === "function" ? _c : Object)
], OpportunityPreviousMediatorDetails.prototype, "mediatorTypeId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => opportunity_entity_1.Opportunity, (opportunity) => opportunity.id, {
        onDelete: "CASCADE",
    }),
    (0, typeorm_1.JoinColumn)({ name: "opportunity_id" }),
    tslib_1.__metadata("design:type", Object)
], OpportunityPreviousMediatorDetails.prototype, "opportunity", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => company_entity_1.Company, (company) => company.id, {
        onDelete: "CASCADE",
    }),
    (0, typeorm_1.JoinColumn)({ name: "company_id" }),
    tslib_1.__metadata("design:type", Object)
], OpportunityPreviousMediatorDetails.prototype, "company", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToOne)(() => country_entity_1.Country, (country) => country.id, {
        onDelete: "CASCADE",
    }),
    (0, typeorm_1.JoinColumn)({ name: "location_id" }),
    tslib_1.__metadata("design:type", Object)
], OpportunityPreviousMediatorDetails.prototype, "location", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToOne)(() => city_entity_1.City, (country) => country.id, {
        onDelete: "CASCADE",
    }),
    (0, typeorm_1.JoinColumn)({ name: "branch_id" }),
    tslib_1.__metadata("design:type", Object)
], OpportunityPreviousMediatorDetails.prototype, "branch", void 0);
exports.OpportunityPreviousMediatorDetails = OpportunityPreviousMediatorDetails = tslib_1.__decorate([
    (0, typeorm_1.Entity)({ name: "opportunity_previous_mediator_details" }),
    tslib_1.__metadata("design:paramtypes", [Number, Number, Number, Number, Number, Number])
], OpportunityPreviousMediatorDetails);
